import logo from './logo.svg';
import './App.css';
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import {LandingHeader} from "./components/landing/LandingHeader";
import LandingPage from "./pages/LandingPage";
import CompanyPage from "./pages/CompanyPage";
import ContactPage from "./pages/ContactPage";
import LandingFooter from "./components/landing/LandingFooter";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import DashboardHeader from "./components/dashboard/DashboardHeader";
import HomePage from "./pages/HomePage";
import SiteDetailsPage from "./pages/SiteDetailsPage";
import LoggerPage from "./pages/LoggerPage";
import TestOnePage from "./pages/TestOnePage";

function App() {
  return (
      <BrowserRouter>
        <LandingLayout />
        <AuthLayout />
        <DashboardLayout />
      </BrowserRouter>
  );
}

const LandingLayout = () => {
  const location = useLocation()

  const isLogin = location.pathname.includes("/login");
  const isForgotPassword = location.pathname.includes("/forgot-password");
  const isDashboard = location.pathname.includes("/dashboard");
  const hideNav =  location.pathname === "/login" || isLogin || isDashboard || isForgotPassword;

  return (
      <>
        {!hideNav &&
            <>
              <LandingHeader />
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/company" element={<CompanyPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
              <LandingFooter />
            </>
        }
      </>
  )

}

const AuthLayout = () => {
  const location = useLocation()

  const isForgotPassword = location.pathname.includes("/forgot-password");

  const hideNav = location.pathname === "/login" || isForgotPassword;

  return (
      <>
        {hideNav &&
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            </Routes>
        }
      </>
  )
}

const DashboardLayout = () => {
  const location = useLocation()

  const isDashboard = location.pathname.includes("/dashboard");

  const hideNav = location.pathname === "/dashboard" || isDashboard;

  return (
      <>
        {hideNav &&
            <div>
              <DashboardHeader />
              <Routes>
                <Route path="/dashboard/:userId/:tabId" element={<HomePage />} />
                <Route path="/dashboard/:userId/:tabId/:siteId" element={<SiteDetailsPage />} />
                <Route path="/dashboard/:userId/:tabId/:siteId/:loggerId" element={<LoggerPage />} />
                <Route path="/dashboard/test" element={<TestOnePage />} />
              </Routes>
            </div>

        }
      </>
  )

}

export default App;
